<template>
	<section>
		<div class="page-head">
			<div>
				<h1 class="page-title">Configuración general</h1>
				<p class="page-sub">Datos del negocio y preferencias del sistema</p>
			</div>
		</div>
		<b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
            <b-breadcrumb-item acive>Configurar</b-breadcrumb-item>
        </b-breadcrumb>
		<form-configuracion :datos="datosNegocio" @registrar="onRegistrar" v-if="datosNegocio"/>
		<b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
	</section>
</template>
<script>
	import FormConfiguracion from './FormConfiguracion'
	import HttpService from '../../Servicios/HttpService'
	import AyudanteSesion from '../../Servicios/AyudanteSesion'

	export default{
		name: "ConfiguracionComponent",
		components: { FormConfiguracion },

		data:()=>({
			cargando: false,
			datosNegocio: null
		}),

		mounted(){
			this.obtenerDatos()
		},

		methods: {
			onRegistrar(datos){
				console.log(datos)
				this.cargando = true
				HttpService.registrar('ajustes.php', {
					accion: 'registrar', 
					ajustes: datos
				})
				.then(resultado =>{
					if(resultado){
						this.cargando = false
						this.$buefy.toast.open({
                          type: 'is-info',
                          message: 'Información actualizada con éxito.'
                        })
                        this.obtenerDatos()
					}
				})
			},

			obtenerDatos(){
				this.cargando = true
				HttpService.obtenerConConsultas('ajustes.php', {
					accion: 'obtener'
				})
				.then(resultado => {
					this.datosNegocio = resultado
					// actualizar los datos del negocio en la sesión/localStorage
					AyudanteSesion.establecerDatosNegocio(resultado)
					this.cargando = false
				})
			}
		}
	}
</script>